const typeNames = {
  'Unconfirmed': 'Неподтвержден',
  'WaitCooking': 'Ожидает готовки',
  'ReadyForCooking': 'Готов к приготовлению',
  'CookingStarted': 'Готовится',
  'CookingCompleted': 'Приготовлено',
  'Waiting': 'Ожидает',
  'OnWay': 'В пути',
  'Delivered': 'Доставлен',
  'Closed': 'Закрыт',
  'Cancelled': 'Отменен',
};

export function translate (key) {
  return typeNames[key] ?? key;
}